<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled
  flat
  :outlined="outlined"

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "hide-details",
    "outlined"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  created() {
    GeocoderFactory().then(geocoder => {
      this.geocoder = geocoder;
      if (this.value.value) {
        this.items.push(this.value);
        this.select = this.value;
      }
    });
  },

  watch: {
    search(val) {
      if (!val) {
        this.resetQuery();
        return;
      }

      const selectedText = typeof this.select === "string"
        ? this.select
        : (this.select && this.select.text);

      if (val === selectedText || val === this.lastSelectedText) {
        return;
      }

      this.querySelections(val);
    }
  },

  mounted() {

  },

  beforeDestroy() {
    this.resetQuery();
  },

  methods: {
    resetQuery() {
      this.querySeq = (this.querySeq || 0) + 1;

      if (this.queryTimer) {
        clearTimeout(this.queryTimer);
        this.queryTimer = null;
      }

      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }

      this.loading = false;
    },

    querySelections(value) {
      this.resetQuery();

      if (!this.geocoder) {
        return;
      }

      const seq = this.querySeq;
      this.loading = true;

      this.queryTimer = setTimeout(() => {
        this.queryTimer = null;

        this.geocoder.autocomplete(value).then(items => {
          if (seq === this.querySeq) {
            this.items = items.slice();
          }
        }).catch(() => {
          if (seq === this.querySeq) {
            this.items = [];
          }
        }).finally(() => {
          if (seq === this.querySeq) {
            this.loading = false;
          }
        });
      }, 150);
    },

    change(o) {
      this.lastSelectedText = o && o.text ? o.text : null;
      this.resetQuery();
      this.$emit("change", o);
    }
  }
};
</script>
